module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor"
  }, [_c('header', [_vm._m(0), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })]), _c('div', {
    key: "accion",
    staticClass: "section"
  }, [_c('div', {
    staticClass: "boton-enviar"
  }, [_c('a', {
    staticClass: "button is-empresa",
    class: {
      'is-loading': _vm.isSending
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._m(1), _c('span', [_vm._v("Enviar reclamo")])])])])]), _c('section', {
    staticClass: "body"
  }, [_c('transition-group', {
    staticClass: "contenedor-transition contenedor-sections",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, [_c('div', {
    key: "seleccionar-local",
    staticClass: "section box"
  }, [_c('box-seleccionar-local', {
    ref: "local",
    on: {
      "selected": _vm.asignarLocal
    }
  })], 1), _c('div', {
    key: "ingresar-datos-consumidor",
    staticClass: "section box"
  }, [_c('box-ingresar-datos-consumidor', {
    ref: "consumidor",
    on: {
      "send": _vm.asignarConsumidor
    }
  })], 1), _c('div', {
    key: "identificacion-bien-contratado",
    staticClass: "section box"
  }, [_c('box-identificacion-bien-contratado', {
    ref: "bien",
    on: {
      "send": _vm.asignarBien
    }
  })], 1), _c('div', {
    key: "detalle-pedido-consumidor",
    staticClass: "section box"
  }, [_c('box-detalle-pedido-consumidor', {
    ref: "detalle",
    on: {
      "send": _vm.asignarDetalle
    }
  })], 1), _c('div', {
    key: "recaptcha"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    staticClass: "recaptcha-container",
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "verify": _vm.onVerify,
      "expired": _vm.onExpired
    }
  })], 1), _c('div', {
    key: "accion",
    staticClass: "section"
  }, [_c('div', {
    staticClass: "boton-enviar"
  }, [_c('a', {
    staticClass: "button is-empresa",
    class: {
      'is-loading': _vm.isSending
    },
    on: {
      "click": _vm.send
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-send-o"
  })]), _c('span', [_vm._v("Enviar reclamo")])])])])])], 1), _c('notifications')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information"
  }, [_c('img', {
    attrs: {
      "src": "/static/libro-reclamaciones.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-send-o"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bef4ad7","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Registrar.vue
// module id = 79
// module chunks = 0